import { render, staticRenderFns } from "./ComplexStrategyForm.vue?vue&type=template&id=b8105f64&scoped=true&"
import script from "./ComplexStrategyForm.vue?vue&type=script&lang=js&"
export * from "./ComplexStrategyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8105f64",
  null
  
)

export default component.exports